/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { ITime, ITimeSerialized } from ".";

export module LinkDataModel {
    export enum ENodeType {
        Project = 0,
        Folder = 1,
        Board = 2,
        ModelGroup = 3
    }

    export module Database {
        export interface ILink {
            id: string;
            projectId: string;
            nodeIdA: string;
            nodeTypeA: ENodeType;
            nodeIdB: string;
            nodeTypeB: ENodeType;
            time: ITime | ITimeSerialized;
        }
    }

    export module Runtime {
        export interface INode {
            id: string;
            type: number;
            parents: string[];
            children: string[];
        }
    }
}
